import React, { useRef } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { images } from '../../utils/imagePaths';
import { MouseScroll } from './CustomArrows';
import "../../styles/banner.css";

const Banner = () => {
  const sliderRef = useRef(null);

  const slides = [
    {
      id: 1,
      tag: 'Government Initiative',
      title: 'Make in India',
      text: 'An initiative by the Government of India to encourage companies to develop, manufacture and assemble products in India and incentivize dedicated investments into manufacturing.',
      image: images.banners.makeInIndia,
      alt: 'Make in India',
    },
    {
      id: 2,
      tag: 'Domestic Production',
      title: 'Made in India',
      text: 'Made in India is a label that accompanies all goods that have been manufactured in India, symbolizing quality and national pride.',
      image: images.banners.madeInIndia,
      alt: 'Made in India',
    },
    {
      id: 3,
      tag: 'GST Compliance',
      title: 'e-Way Bill',
      text: 'A document issued by a carrier giving details relating to the shipment of goods — names of consignor and consignee, point of origin, destination, and route.',
      image: images.banners.eWayBill,
      alt: 'e-Way Bill',
    },
    {
      id: 4,
      tag: 'Digital Invoicing',
      title: 'e-Invoice Bill',
      text: 'A digital document exchanged between supplier and buyer and validated by the government tax portal — enabling faster, error-free B2B transactions authenticated by GSTN.',
      image: images.banners.hospitalSolutions,
      alt: 'e-Invoice Bill',
    },
    {
      id: 5,
      tag: 'Tax Filing',
      title: 'GST Returns',
      text: 'A document containing all details of your sales, purchases, output tax, and input tax. File GST returns accurately and pay the resulting tax liability with ease.',
      image: images.banners.gstReturns,
      alt: 'GST Returns',
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    pauseOnHover: true,
    cssEase: 'ease-in-out',
  };

  return (
    <section className="banner" id="home">
      <div className="banner-container">
        <Slider ref={sliderRef} {...settings} className="banner-slider">
          {slides.map((slide) => (
            <div key={slide.id} className="banner-slide">
              <div className="banner-tile">
                <div className="container">
                  <div className="banner-inner">

                    {/* Left: text */}
                    <motion.div
                      className="banner-content"
                      initial={{ opacity: 0, y: 24 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.1 }}
                    >
                      <span className="banner-tag">{slide.tag}</span>
                      <h1 className="banner-title">{slide.title}</h1>
                      <p className="banner-text">{slide.text}</p>
                      <a href="#contact-us" className="banner-btn">
                        Get in Touch
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </a>
                    </motion.div>

                    {/* Right: image */}
                    <motion.div
                      className="banner-image-wrap"
                      initial={{ opacity: 0, y: 24 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.25 }}
                    >
                      <img src={slide.image} alt={slide.alt} className="banner-image" />
                    </motion.div>

                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Manual prev/next */}
        <button className="banner-arrow banner-prev" onClick={() => sliderRef.current?.slickPrev()} aria-label="Previous">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 5l-7 7 7 7" />
          </svg>
        </button>
        <button className="banner-arrow banner-next" onClick={() => sliderRef.current?.slickNext()} aria-label="Next">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <motion.div
          className="scroll-anim"
          animate={{ y: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
        >
          <MouseScroll />
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;